import { render, staticRenderFns } from "./AI_FeatureList.vue?vue&type=template&id=27d99f98&scoped=true&"
import script from "./AI_FeatureList.vue?vue&type=script&lang=js&"
export * from "./AI_FeatureList.vue?vue&type=script&lang=js&"
import style0 from "./Spatial_Intelligence.css?vue&type=style&index=0&id=27d99f98&prod&scoped=true&lang=css&"
import style1 from "./AI_FeatureList.vue?vue&type=style&index=1&id=27d99f98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d99f98",
  null
  
)

export default component.exports